import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Grid
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SampleImage from "../Images/UlapRecPictures/1.jpg"; 
import ImageOne from "../Images/UlapRecPictures/4.png"; 

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    height: 160,
  },
  cardContent: {
    flexGrow: 1,
  },
  title: {
    marginBottom: theme.spacing(4),
    fontWeight: 'bold',
    textAlign: 'center',
  }
}));

function Feature() {
  const classes = useStyles();

  const features = [
    {
      title: "Job Posting",
      description: "Create and publish job openings in minutes.",
      image: ImageOne
    },
    {
      title: "One Click Scheduling",
      description: "Automate screening calendars and sync interviews smoothly. ",
      image: SampleImage
    },
    {
      title: "Built-in Exam & Evaluation Tools",
      description: "Design custom tests, track applicant results, and score fairly with structured evaluation forms.",
      image: SampleImage
    },
    {
      title: "Real-Time Feedback",
      description: "Evaluate interviews collaboratively with standardized scorecards.",
      image: SampleImage
    },
    {
      title: "Centralized Hiring Hub",
      description: "Manage every applicant, exam, and interview in one place. ",
      image: SampleImage
    },
  ];

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Grid container spacing={4}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={12} md={4} lg={4} key={index}>
            <Card className={classes.card}>
              <CardMedia
                className={classes.cardMedia}
                image={feature.image}
                title={feature.title}
              />
              <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="h6" component="h2">
                  {feature.title}
                </Typography>
                <Typography>
                  {feature.description}
                </Typography>
              </CardContent>
              <CardActions>
                {/* <Button size="small" color="primary">
                  Learn More
                </Button> */}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Feature;
